// Capture state shared across the 3-step signup flow.
import { createContext, useContext, useMemo, useState } from "react";

const CaptureCtx = createContext(null);

const initial = {
  firstName: "",
  lastName: "",
  email: "",
  zip: "",
  phone: "",
  password: "",
  smsOptIn: false,
  signupSource: "organic",
  referralCode: "",
  turnstileToken: "",
  deviceFingerprint: "",
};

export function CaptureProvider({ children }) {
  const [data, setData] = useState(initial);
  const update = (patch) => setData((prev) => ({ ...prev, ...patch }));
  const value = useMemo(() => ({ data, update, reset: () => setData(initial) }), [data]);
  return <CaptureCtx.Provider value={value}>{children}</CaptureCtx.Provider>;
}

export function useCapture() {
  const ctx = useContext(CaptureCtx);
  if (!ctx) throw new Error("useCapture must be inside CaptureProvider");
  return ctx;
}
